import React, { useContext, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { useParams } from "react-router";

import ModalHolder from "../../molecules/ModalHolder";
import { toastError } from "../../../shared/helpers";
import { UpdateScheduleFormOne, UpdateScheduleFormTwo } from "../../templates/Case";
import { UPDATE_CASE_SCHEDULE } from "../../../shared/queries";
import { authContext } from "../../../shared/store/contexts";

const UpdateCaseScheduleModal = ({
  closeModal,
  schedule,
  _case,
  showSuccessModal,
}) => {
  const { id: organizationId } = useParams();

  const [step, setStep] = useState(1);
  const [fields, setFields] = useState();
  const [loading, setLoading] = useState(false);
  const { auth } = useContext(authContext);

  const updateFields = (data) => {
    setFields({ ...fields, ...data });
    setStep(2);
  };

  const [updateSchedule] = useMutation(UPDATE_CASE_SCHEDULE);

  const onUpdateSchedule = (data) => {
    setLoading(true);

    updateSchedule({
      variables: {
        data: {
          title: fields.title,
          location: fields.location,
          locationDetails: fields.locationDetails,
          date: data.date,
          duration: data.duration,
          time: data.time,
          caseScheduleId: schedule?.id,
          schedulerEmail: auth?.user?.email,
          organizationId,
        },
      },
    })
      .then(() => {
        showSuccessModal();
        closeModal();
      })
      .catch((error) => {
        toastError(error.message);
      });
  };

  const formCtx = useForm();

  useEffect(() => {
    setFields(schedule);
  }, []);

  return (
    <ModalHolder width="60%" closeModal={closeModal}>
      <FormProvider {...formCtx}>
        {step === 1 && (
          <UpdateScheduleFormOne
            closeModal={closeModal}
            fields={fields}
            _case={_case}
            updateFields={updateFields}
          />
        )}
        {step === 2 && (
          <UpdateScheduleFormTwo
            closeModal={closeModal}
            loading={loading}
            fields={fields}
            _case={_case}
            onUpdateSchedule={onUpdateSchedule}
          />
        )}
      </FormProvider>
    </ModalHolder>
  );
};

export default UpdateCaseScheduleModal;
